// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".amazon-pay .amazonpay-login #amazonPayButton[data-v-4ba2e2f0]{display:block;margin:15px auto;width:200px}.amazon-pay .amazonpay-wallet #walletWidgetDiv[data-v-4ba2e2f0]{height:228px;margin-top:15px;max-height:400px}.amazon-pay .clearfix[data-v-4ba2e2f0]:after{clear:both;content:\"\";display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
